import { useSelector } from 'react-redux';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { RedText } from '../SystemWebhooks.styled';
import { getSystemWebhookState } from '../selectors';
import { WEBHOOK_ERRORS, ENDPOINT_HELP_TEXT } from '../constants';
import { SystemWebhookFormState } from '../types';

export const EndpointFormField = ({
  updateWebhook,
  webhook,
}: {
  updateWebhook: (field: string, value: string) => void;
  webhook: SystemWebhookFormState;
}) => {
  const systemWebhookState = useSelector(getSystemWebhookState);
  const errors = (systemWebhookState as Record<string, any>)?.errors;

  const isMissingUrl = errors.includes(WEBHOOK_ERRORS.MISSING_URL);
  const isInvalidUrl = errors.includes(WEBHOOK_ERRORS.INVALID_URL);

  return (
    <FormField
      errorText={isMissingUrl ? 'Please enter an endpoint URL' : 'Please enter a valid webhook URL'}
      hasError={isMissingUrl || isInvalidUrl}
      helpText={
        <span>
          Use <RedText data-highlight>{ENDPOINT_HELP_TEXT}</RedText> to encode parameters
        </span>
      }
      inputId="webhookEndpoint"
      labelText="Endpoint URL"
      isRequired
    >
      <InputText
        id="webhookEndpoint"
        hasError={isMissingUrl || isInvalidUrl}
        placeholder="https://www.example.com/webhook"
        onChange={(value: string) => {
          updateWebhook('endpoint', value);
        }}
        data-test="webhookEndpointInput"
        value={webhook.endpoint}
      />
    </FormField>
  );
};
